/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED ADs RAIL PLACEMENT : STYLES --------------- ++++++++++ */
export default theme => ({
    rail: {
        animationName: 'fadeInRight',

        '& .visual': {
            '& .device': {
                backgroundImage: `url(${url.image}/mks/graphic-placement-rail-large.png)`,
                width: pxToEm(673),
                height: pxToEm(443),
                '& .embed-container': {
                    width: pxToEm(179),
                    top: pxToEm(35),
                    right: pxToEm(85),
                    '& .ad': {
                        '&.inline': {
                            height: pxToEm(113)
                        }
                    },
                    '& .embed': {
                        backgroundImage: `url(${url.image}/mks/graphic-embed-profiling-rail.png)`,
                        height: pxToEm(155)
                    }
                }
            }
        }
    }
});
